import {
  Button,
  Center,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Icon,
} from '@chakra-ui/react';
import { XIcon } from '@heroicons/react/solid';
import { KText } from '@/ui-library/components/text';
export const ModalSlider = ({
  onSubmit = () => {},
  onClose = () => {},
  submitButtonLabel = 'Submit',
  cancelButtonLabel = 'Cancel',
  submitButtonIsLoading = false,
  primaryVariant = 'primary',
  showFooter = true,
  modalHeader = null,
  modalBody = <></>,
  header = {
    title: 'header title',
    subtitle: 'header subtitle',
  },
  disablePrimayButton = false,
}) => {
  return (
    <Drawer isOpen={true} placement="right" onClose={onClose}>
      <DrawerOverlay zIndex="1400" />
      <DrawerContent w="720px" maxW="720px" borderTopLeftRadius="xl">
        <Center
          w="48px"
          h="48px"
          left="-70px"
          top="32px"
          pos="absolute"
          bg="#fff"
          borderRadius="full"
          onClick={onClose}
          cursor="pointer"
        >
          <Icon as={XIcon} w="20px" h="20px" />
        </Center>
        <DrawerHeader
          borderBottom="1px solid"
          borderColor="border-color"
          p="25px 30px"
        >
          {modalHeader ? (
            modalHeader
          ) : (
            <>
              <KText size="md-semi-bold" color="secondary-900">
                {header.title}
              </KText>
              <KText size="sm-regular" color="secondary-700">
                {header.subtitle}
              </KText>
            </>
          )}
        </DrawerHeader>

        <DrawerBody px="30px">{modalBody}</DrawerBody>
        {showFooter && (
          <DrawerFooter borderTop="1px solid" borderColor="border-color">
            <Button variant="secondary" mr={3} onClick={onClose}>
              {cancelButtonLabel}
            </Button>
            <Button
              variant={primaryVariant}
              onClick={onSubmit}
              disabled={disablePrimayButton}
              isLoading={submitButtonIsLoading}
            >
              {submitButtonLabel}
            </Button>
          </DrawerFooter>
        )}
      </DrawerContent>
    </Drawer>
  );
};
